import { render, staticRenderFns } from "./add-distributed.vue?vue&type=template&id=3cae0e9e&scoped=true&"
import script from "./add-distributed.vue?vue&type=script&lang=ts&"
export * from "./add-distributed.vue?vue&type=script&lang=ts&"
import style1 from "./add-distributed.vue?vue&type=style&index=1&id=3cae0e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cae0e9e",
  null
  
)

export default component.exports